
import React, { useState, useEffect } from "react";
import {
  Box,
  AppBar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Divider,
  Dialog,
} from "@mui/material";
import {
  Home as HomeIcon,
  AccountCircle as ProfileIcon,
  LibraryBooks as TestIcon,
  Menu as MenuIcon,
  CardGiftcardOutlined,
  Settings as SettingsIcon,
  Description as TermsIcon,
  Lock as PrivacyIcon,
  Article as NewsIcon,
} from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import logoImg from "../static/img/header/logo.svg";
import { SvgIcon } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import TestSkillsDialog from "../components/TestSkillsDialog";
import GiftCard from "../components/GiftCard"; //////// Added GiftCard
import EggGiftCard from "../components/EggGiftCard";

const BackIcon = () => (
  <SvgIcon sx={{ fontSize: "24px" }}>
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none">
      <path
        d="M21 11C21 13.0767 20.3842 15.1068 19.2304 16.8335C18.0767 18.5602 16.4368 19.906 14.5182 20.7007C12.5996 21.4955 10.4884 21.7034 8.45155 21.2982C6.41475 20.8931 4.54383 19.8931 3.07538 18.4246C1.60693 16.9562 0.606899 15.0852 0.201756 13.0484C-0.20339 11.0116 0.00454521 8.90045 0.799265 6.98182C1.59398 5.0632 2.9398 3.42332 4.66651 2.26957C6.39323 1.11581 8.4233 0.5 10.5 0.5C13.2848 0.5 15.9555 1.60625 17.9246 3.57538C19.8938 5.54451 21 8.21523 21 11ZM16.5 10.25H7.3875L11.5725 6.04475L10.5 5L4.5 11L10.5 17L11.5725 15.9298L7.3875 11.75H16.5V10.25Z"
        fill="#FAAE1C"
      />
    </svg>
  </SvgIcon>
);

function LayoutMobile({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const gameUuid = queryParams.get("game");
  const [value, setValue] = useState(location.pathname);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openTestSkills, setOpenTestSkills] = useState(false);
  const [openEggCard, setOpenEggCard] = useState(false); ///////  State for EggGiftCard
  const theme = useTheme();

  useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleNavigation = (action) => {
    if (typeof action === "function") {
      action();
    } else if (typeof action === "string") {
      navigate(action);
    }
    setIsSidebarOpen(false);
  };

  const menuItems = [
    { icon: HomeIcon, label: "Home", action: "/" },
    { icon: NewsIcon, label: "News", action: "/news" },
    { icon: ProfileIcon, label: "Profile", action: "/profile" },
    {
      icon: TestIcon,
      label: "Test your Skills",
      action: () => setOpenTestSkills(true),
    },
    {
      icon: CardGiftcardOutlined,
      label: "Win a Gift",
      action: "/puzzle",
    },
    { type: "divider" },
    { icon: TermsIcon, label: "Terms of Service", action: "/terms" },
  ];

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <AppBar
        position="static"
        sx={{
          bgcolor: "rgba(0, 0, 0, 0.5)",
          boxShadow: "none",
          maxHeight: location.pathname === "/article-view" ? "56px" : "150px",
          minHeight: location.pathname === "/article-view" ? "56px" : "auto",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding:
            location.pathname === "/article-view" ? "16px 10px" : "0 10px",
        }}
      >
        {location.pathname === "/game" ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <ArrowBackRounded
              onClick={() => {
                navigate("/");
                window.location.reload();
              }}
              sx={{ cursor: "pointer", color: "white" }}
            />
            <Typography
              variant="h6"
              sx={{
                textAlign: "left",
                color: "white",
                fontFamily: "'Azonix', sans-serif",
              }}
            >
              {gameUuid}
            </Typography>
          </Box>
        ) : location.pathname === "/article-view" ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Box
              onClick={() => navigate(-1)}
              sx={{ cursor: "pointer", display: "flex", alignItems: "center" }}
            >
              <BackIcon />
            </Box>
            <Typography
              variant="h6"
              sx={{
                textAlign: "left",
                color: "white",
                fontFamily: "'Poppins', sans-serif",
                fontSize: "18px",
                fontWeight: "500",
                textTransform: "capitalize",
              }}
            >
              {location.state?.gameName}{" "}
              {location.state?.article?.type || "Article"}
            </Typography>
          </Box>
        ) : (
          <img
            src={logoImg}
            alt="GamezAcademy"
            style={{ height: "auto", width: "120px", padding: "8px" }}
            onClick={() => {
              navigate("/");
              window.location.reload();
            }}
          />
        )}
        <MenuIcon
          onClick={toggleSidebar}
          sx={{ cursor: "pointer" }}
          color="primary"
        />
      </AppBar>

      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          backgroundColor: theme.palette.background.paper,
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
        }}
      >
        {children}
      </Box>

      <Drawer anchor="right" open={isSidebarOpen} onClose={toggleSidebar}>
        <Box
          role="presentation"
          sx={{
            width: "250px",
            backgroundColor: "#1e1e1e",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <List>
            {menuItems.map((item, index) =>
              item.type === "divider" ? (
                <Divider key={`divider-${index}`} sx={{ my: 2 }} />
              ) : (
                <React.Fragment key={item.label}>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => handleNavigation(item.action)}
                      sx={{
                        color:
                          location.pathname === item.action
                            ? "#FFD700"
                            : "text.primary",
                        "&:hover": {
                          backgroundColor: "rgba(0, 0, 0, 0.04)",
                        },
                      }}
                    >
                      <ListItemIcon>
                        <item.icon
                          sx={{
                            color:
                              location.pathname === item.action
                                ? "#FFD700"
                                : "primary.main",
                          }}
                        />
                      </ListItemIcon>
                      <ListItemText primary={item.label} />
                    </ListItemButton>
                  </ListItem>
                  {/*  Show GiftCard right below Terms of Service */}
                  {item.label === "Terms of Service" && (
                    <Box sx={{ p: 2 }}>
                      <GiftCard onWatchNow={() => setOpenEggCard(true)} />
                    </Box>
                  )}
                </React.Fragment>
              )
            )}
          </List>
        </Box>
      </Drawer>

      {/*  Directly render EggGiftCard */}
<EggGiftCard
  open={openEggCard}
  onClose={() => setOpenEggCard(false)}
  onStart={() => {
    setOpenEggCard(false);
    alert("Starting...");
  }}
/>

      <TestSkillsDialog
        open={openTestSkills}
        onClose={() => setOpenTestSkills(false)}
      />
    </Box>
  );
}

export default LayoutMobile;